import React from "react";

function VideoOnly() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="211"
      height="124"
      fill="none"
      viewBox="0 0 211 124"
    >
      <path stroke="#000" d="M0.5 0.5H210.5V102.5H0.5z"></path>
      <path
        fill="#000"
        d="M111.887 50.351l-9.753-5.806a.752.752 0 00-1.134.645v11.38a.755.755 0 00.374.647.748.748 0 00.748.003l9.754-5.573a.747.747 0 00.281-1.02.746.746 0 00-.27-.276zM102 56.138V45.63l9.008 5.361L102 56.138z"
      ></path>
    </svg>
  );
}

export default VideoOnly;
